import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import { TabContext, TabList, TabPanel } from '@mui/lab';

// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
// sections
import { LoginForm } from '../sections/auth/login';
import { CreateAccountForm } from '../sections/auth/create-account';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  const [tabNumber, setTabNumber] = useState('0');
  const handleTabChange = (event, newTabIndex) => {
    setTabNumber(newTabIndex);
  };

  return (
    <>
      <Helmet>
        <title> Login | VPSI Site </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hello and Welcome to VPSI!
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} aria-label="login or create account tab">
                  <Tab label="Login" value="0" />
                  <Tab label="Create Account" value="1" />
                </TabList>
              </Box>
              <TabPanel value="0">
                <Typography variant="h4" gutterBottom>
                  Sign in to VPSI!
                </Typography>
                <LoginForm />
              </TabPanel>
              <TabPanel value="1">
                <Typography variant="h4" gutterBottom>
                  Create your Account!
                </Typography>
                <CreateAccountForm />
              </TabPanel>
            </TabContext>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
